import { NotificationChip, NotificationIconButton } from './NotificationIcon'
import { NotificationList } from './NotificationList'
import { useGetNotifications } from './useGetNotifications'

export const NotificationBadge = ({ isDvi }: { isDvi?: boolean }) => {
  const {
    notifications,
    numUnreadNotifications,
    loadingNotifications,
    setNotificationEndTime,
    notificationAnchorEl,
    setNotificationAnchorEl,
    fetchingNotifications,
    refetchNotifications
  } = useGetNotifications()

  return (
    <>
      {isDvi ? (
        <NotificationIconButton
          {...{
            numUnreadNotifications,
            notificationAnchorEl,
            setNotificationAnchorEl,
            refetchNotifications
          }}
        />
      ) : (
        <NotificationChip
          {...{
            numUnreadNotifications,
            notificationAnchorEl,
            setNotificationAnchorEl,
            refetchNotifications
          }}
        />
      )}
      <NotificationList
        {...{
          notifications,
          numUnreadNotifications,
          loadingNotifications,
          fetchingNotifications,
          setNotificationEndTime,
          notificationAnchorEl,
          setNotificationAnchorEl,
          isDvi
        }}></NotificationList>
    </>
  )
}
